module.exports = __webpack_public_path__ + "static/media/backArrow.4e64fd95.svg";